import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div>
      <div>
        <Link to={"/new"}>
          <button className="m-10 px-2 py-1 bg-yellow-500 uppercase font-extrabold rounded-lg hover:bg-lime-400 ">
            new busines
          </button>
        </Link>
      </div>
      <div>
        <Link to={"/update"}>
          <button className="m-10 px-2 py-1 bg-yellow-500 uppercase font-extrabold rounded-lg hover:bg-lime-400 ">
            update data
          </button>
        </Link>
      </div>
    </div>
  );
}

export default Home;
